<script>
import { mapState } from 'vuex';

export default {
  name: 'CustomBtn',
  data () {
    return {
      isShowDownload: false
    };
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapState('publicStore', ['isShowAppDownload', 'publicConfig']),
    navList () {
      //  H5游客用户每日限制观看XX部完整片源    h5_customer_watch
      // 注册用户即刻解锁x天全场片源（包含付费/会员片源） register_unlock_watch
      // 下载APP登录即送x天会员 download_app_watch
      let base = [
        {
          key: 1,
          icon: require('./assets/app.png'),
          name: 'invite',
          title: '下载APP',
          subtitle: '登录即送',
          subtitle1: `${this.publicConfig?.download_app_watch}天会员`
        }
      ];
      // 如果是游客账号，显示加入我们
      if (!this.userInfo?.token || this.userInfo.is_tourist === 1) {
        base = [
          {
            key: 2,
            icon: require('./assets/join.png'),
            name: 'login',
            title: '加入我们',
            subtitle: '登录即送',
            subtitle1: `${this.publicConfig?.register_unlock_watch}天会员`
          }, ...base
        ];
      }
      // 如果是不是会员则显示充值
      if (!this.userInfo?.is_vip) {
        base = [
          {
            key: 3,
            icon: require('./assets/vip.png'),
            name: 'memberRecharge'
          }, ...base
        ];
      }
      return base;
    }
  },
  watch: {
    isShowAppDownload (val) {
      this.isShowDownload = val;
    }
  },
  methods: {
    go (item) {
      if (item.key === 1) {
        // 弹出下载
        this.isShowDownload = true;
        return;
      }
      this.$router.push(`/${item.name}`);
    },
    closePopup () {
      this.isShowDownload = false;
      this.$store.commit('publicStore/setIsShowAppDownload', false);
    },
    download (type) {
      this.$store.commit('publicStore/setIsShowAppDownload', false);
      if (type === 'android') {
        window.location.href = this.publicConfig.download_url?.android_download_url;
      } else {
        window.location.href = this.publicConfig.download_url?.ios_download_url;
      }
    }
  }
};
</script>

<template>
  <div>
    <div class="custom-box">
      <div class="custom-btn" v-for="(item, index) in navList" :key="index" @click="go(item)">
        <img :src="item.icon" alt="" />
        <div :class="`custom-text ${item.name}-btn`">
          <div>{{ item.title }}</div>
          <div>{{ item.subtitle }} <span>{{ item.subtitle1 }}</span></div>
        </div>
      </div>
    </div>
    <md-popup
      v-model="isShowDownload"
      position="bottom"
      class="download-popup"
    >
      <div class="download-box">
        <div class="close">
          <img
            @click="closePopup"
            :src="require('./assets/close.png')"
            alt=""
          />
        </div>
        <div class="download-content">
          <div class="download-img">
            <img :src="siteConfig.favicon" alt="" />
          </div>
          <div class="download-text">
            <div class="download-title">下载APP</div>
            <div class="download-content">登陆即送<span>{{ publicConfig.download_app_watch }}</span>天会员</div>
          </div>
        </div>
        <div class="download-footer">
          <div class="download-andriod" @click="download('android')">
            <img :src="require('./assets/andriod.png')" alt="" />
            <span>安卓下载</span>
          </div>
          <div class="download-ios" @click="download('ios')">
            <img :src="require('./assets/ios.png')" alt="" />
            <span>IOS下载</span>
          </div>
        </div>
      </div>
    </md-popup>
  </div>
</template>

<style scoped lang="scss">
.custom-box {
  position: fixed;
  bottom: 80px;
  right: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 100;
  width: 60px;
  .custom-btn {
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    position: relative;
    img {
      width: 100%;
      height: 100;
      margin-bottom: 6px;
    }
  }
  .custom-text {
    width: 100%;
    font-size: 7.7px;
    color: #333;
    text-align: left;
    position: absolute;
    bottom: 4px;
    left: 50%;
    transform: translateX(-50%);
    font-family: WDCH;
    &.invite-btn {
      color: #E04801;
      font-weight: bold;
      padding-left: 5px;
      text-shadow:
        -0.3px -1px 0 #17587E,
        0.3px -1px 0 #17587E,
        -0.3px  1px 0 #17587E,
        0.3px  1px 0 #17587E;
      line-height: 9px;
      div:nth-child(1) {
        text-align: left;
        color: #FFFFFF;
        font-size: 7.7px;
      }
      div:nth-child(2) {
        color: #FFFFFF;
        font-size: 5.3px;
        padding-left: 2px;
        span {
          font-weight: bold;
          color: #FFC941;
          font-size: 7.5px;
        }
      }
    }
    &.login-btn {
      color: #E04801;
      font-weight: bold;
      padding-left: 5px;
      // -webkit-text-stroke: 0.2px #17587E;
      text-shadow:
        -0.3px -1px 0 #17587E,
        0.3px -1px 0 #17587E,
        -0.3px  1px 0 #17587E,
        0.3px  1px 0 #17587E;
      line-height: 9px;
      div:nth-child(1) {
        text-align: center;
        color: #FFFFFF;
        font-size: 7.7px;
      }
      div:nth-child(2) {
        color: #FFFFFF;
        font-size: 5.3px;
        span {
          font-weight: bold;
          color: #FFC941;
          font-size: 7.5px;
        }
      }
    }
  }
}
.download-popup {
  width: 100%;
  z-index: 99999;
  .download-box {
    padding: 20px;
    background: hsla(0,0%,86.7%, .9);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    text-align: center;
    .close {
      width: 23px;
      height: 23px;
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .download-content {
      display: flex;
      align-items: center;
      .download-img {
        height: 60px;
        width: 60px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .download-text {
        margin-left: 10px;
        text-align: left;
        color: #333;
        .download-title {
          font-size: 20px;
          font-weight: bold;
        }
        .download-content {
          font-size: 20px;
          span {
            font-weight: bold;
            color: #E04801;
            font-size: 32px;
            padding: 0 5px;
          }
        }
      }
    }
    .download-footer {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      .download-andriod,
      .download-ios {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 5px;
        background: #D9D9D9;
        flex: 1;
        height: 40px;
        border: 1px solid #32B8AF;
        img {
          width: 24px;
          height: 24px;
          margin-right: 5px;
        }
        span {
          font-size: 14px;
          color: #32B8AF;
        }
      }
      .download-ios {
        background: #32B8AF;
        span {
          color: #fff;
        }
      }
    }
  }
}
</style>
